module.exports = require("@ckeditor/ckeditor5-build-classic/build/translations/pt-br");